import axios from 'axios';
import { normalize } from 'normalizr';
import { createEducator, createStudent, createProfessional } from 'Root/api/user';
import * as types from './types';

import { userSchema } from './schema';

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = 'X-CSRFToken';

export function getUser({ userId }) {
  return {
    type: types.USER_GET,
    async payload() {
      const response = await axios.get(`/api/v1/user/${userId}/`);
      return normalize(response.data, userSchema).entities.users;
    },
  };
}

export function getCurrentUser() {
  return getUser({ userId: 'current' });
}

export function createEducatorAction(data) {
  return {
    type: types.EDUCATOR_CREATE,
    async payload() {
      const response = await createEducator(data);
      return normalize(response, userSchema).entities.users;
    },
  };
}

export function changeUser({ userId, data = {} }) {
  return {
    type: types.USER_CHANGE,
    payload: {
      async promise() {
        const response = await axios.patch(`/api/v1/user/${userId}/`, data);
        return normalize(response.data, userSchema).entities.users;
      },
      data: { [userId]: data },
    },
    meta: {
      userId,
    },
  };
}

export function feedbackReceivementSwitch({ userId, enabled }) {
  return changeUser({
    userId,
    data: {
      feedbackReceivement: enabled,
    },
  });
}

export function selectUser({ userId }) {
  return {
    type: types.USER_SELECT,
    meta: {
      userId,
    },
  };
}

export function createStudentAction(data) {
  return {
    type: types.STUDENT_CREATE,
    async payload() {
      const response = await createStudent(data);
      return normalize(response, userSchema).entities.users;
    },
  };
}

export function updateStudentDetailsAction(addedStudentDetails, userId) {
  return {
    type: types.STUDENT_UPDATE,
    payload: {
      async promise() {
        const response = await axios.patch(`/api/v1/student/signup/${userId}/`, addedStudentDetails);
        return normalize(response.data, userSchema).entities.users;
      },
    },
    meta: {
      userId,
    },
  };
}

export function createProfessionalAction(data) {
  return {
    type: types.PROFESSIONAL_CREATE,
    async payload() {
      const response = await createProfessional(data);
      return normalize(response, userSchema).entities.users;
    },
  };
}

export function updateProfessionalDetailsAction(addedProfessionalDetails, userId) {
  return {
    type: types.PROFESSIONAL_UPDATE,
    payload: {
      async promise() {
        const response = await axios.patch(`/api/v1/professional/signup/${userId}/`, addedProfessionalDetails);
        return normalize(response.data, userSchema).entities.users;
      },
    },
    meta: {
      userId,
    },
  };
}
